module.exports = __webpack_public_path__ + "static/website-ver2-290a2694e8d5e986d309d1d0251c7c18.mp4";